<template>
  <div class="profile-container">
     <b-modal v-model="showModal" title="Download Options" hide-footer>
        <div>
          <b-form-group label="Choose download type:">
            <b-form-radio v-model="downloadOption" name="download-option" value="without">
              Without Institution Header
            </b-form-radio>
            <b-form-radio v-model="downloadOption" name="download-option" value="with">
              With Institution Header
            </b-form-radio>
          </b-form-group>

          <div class="text-right">
            <b-button variant="primary" @click="downloadStudentRecord()">Download</b-button>
            <b-button variant="secondary" @click="showModal = false">Cancel</b-button>
          </div>
        </div>
      </b-modal>

    <b-row class="align-items-center justify-content-between g-0">
      <b-col class="text-center" cols="auto">
        <div style="position: relative; display: inline-block;" v-if="!from_parent_login">
          <img :src="require('../../../../../../../assets/images/login1.png')" alt="Institution Logo"
            class="img-fluid mx-auto d-block"
            style="width: 60px; height: auto; border-radius: 10%; filter: brightness(0);" />
          <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; 
               background-color: #add8e6; mix-blend-mode: screen; 
               border-radius: 10%; pointer-events: none;">
          </div>
        </div>
      </b-col>
      <b-col class="text-center" cols="auto" v-if="!from_parent_login && groupInfo">
        <p class="institution-name" style="font-size: 2.5rem; font-weight: bold; color: #34495e; 
           font-family: 'Georgia', serif; text-transform: uppercase; margin: 0; margin-left: 120px;">
          {{ userSubGroup.institution.name }}
        </p>
      </b-col>
      <b-col class="text-center" cols="auto" v-if="!from_parent_login && !groupInfo">
        <p class="institution-name" style="font-size: 2.5rem; font-weight: bold; color: #34495e; 
           font-family: 'Georgia', serif; text-transform: uppercase; margin: 0; margin-left: 120px;">
          {{ institutionUserPersonalDetails.institution.name }}
        </p>
      </b-col>      
      <b-col class="text-right" cols="auto" v-if="!from_parent_login && !show_basic_info_only">
        <!-- Download Button -->
        <b-button
          variant="info"
          class="custom-action-btn mr-2"
          @click="showDownloadPopup()"
        >
          Download
        </b-button>

        <!-- Close Button -->
        <b-button
          variant="danger"
          class="custom-action-btn"
          @click="$emit('cancelProfile')"
          v-if="!from_staff_student_list"
        >
          Cancel
        </b-button>
      </b-col>
     <b-col class="text-right" cols="auto" v-if="from_parent_login && !show_basic_info_only">
      <i
        class="fas fa-download text-info"
        style="font-size: 16px; cursor: pointer;"
        @click="downloadStudentRecord()"
      ></i>
    </b-col>
    </b-row>
    <b-row class="align-items-center justify-content-between g-0" v-if="!from_parent_login && groupInfo">
      <b-col cols="auto" class="d-flex justify-content-center align-items-center"></b-col>
      <b-col cols="auto" class="text-center">
        <span style="font-size: 1.2rem; font-weight: 600; color: #34495e; margin-right: 8px;">
          {{ userSubGroup.usergroup.name }}
        </span>
        <span style="font-size: 1.2rem; font-weight: 600; color: #bdc3c7; margin: 0 8px;">
          |
        </span>
        <span style="font-size: 1.2rem; font-weight: 600; color: #34495e; margin-left: 8px;">
          {{ userSubGroup.usergroup.maingroup.name }}
        </span>
      </b-col>
      <b-col cols="auto" class="d-flex justify-content-end align-items-center"></b-col>
    </b-row>
    <div class="student-profile">
      <!-- Academic Information --> 
      <academic-information v-if="!from_parent_login || (from_parent_login && show_basic_info_only)"
        :details="institutionUserPersonalDetails"
        :enrollmentNo="enrollmentNo"
      />
      <!-- Personal Details -->
      <user-personal-details v-if="!from_parent_login || (from_parent_login && show_basic_info_only)"
        :details="institutionUserPersonalDetails"
      />

      <!-- Guardian-Details -->
      <guardian-details v-if="!from_parent_login || (from_parent_login && show_basic_info_only)"
        :guardians="institutionUserPersonalDetails.guardians"
        :from-parent-login="from_parent_login"
        :show_basic_info_only="show_basic_info_only"/>

      <!-- siblings-details  -->
      <siblings-details v-if="!from_parent_login  || (from_parent_login && show_basic_info_only)"
        :siblings="institutionUserPersonalDetails.siblings"/>

      <!-- academic-details -->
      <academic-details v-if="!show_basic_info_only"
        :student-academic-details="studentAcademicDetails" 
        :universityExamsDetails="studentUniversityExamsDetails"/>

    </div>
  </div>
</template>

<script>
import AcademicInformation from './AcademicInformation.vue';
import UserPersonalDetails from './UserPersonalDetails.vue';
import AcademicDetails from './AcademicDetails.vue';
import GuardianDetails from './GuardianDetails.vue';
import SiblingsDetails from './SiblingsDetails.vue';

export default {
  props: ["groupInfo", "institutionUserId", "sortByOrder", "from_parent_login"
  , "show_basic_info_only", "parentSelectedSubgroupId", "from_staff_student_list", "enrollmentNo"],
  components: {
    AcademicInformation,
    UserPersonalDetails,
    AcademicDetails,
    GuardianDetails,
    SiblingsDetails
  },
  data() {
    return {
      institutionUserPersonalDetails: [],
      userSubGroup: [],
      studentAcademicDetails: [],
      studentUniversityExamsDetails: [],
      showModal: false,
      downloadOption: "with",
    };
  },
  async created() {
    await this.getAcademicDetails();
    if (!this.from_parent_login) {
        await this.getSubGroup();
    }
  },
  methods: {
    showDownloadPopup() {
      this.showModal = true;
    },
    async downloadStudentRecord() {
      this.showModal = false;
      this.loadingPdf = true;
      let url = ""; 
      let params = {};

      if (this.from_parent_login) {
        url = `${this.$store.getters.getAPIKey.mainAPI}/parentuser/usersubgroupuser/academicdetails/pdfexport`;
        params = {
          institution_user_id: this.institutionUserId,
          subgroupId: this.parentSelectedSubgroupId,
          show_academic_details_only : true,
          downloadOption : this.downloadOption
        };
      } else {
        url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroupuser/academicdetails/pdfexport`; // Assign url properly
        params = {
          usersubgroup_id: this.groupInfo? this.groupInfo.id:null,
          institution_user_id: this.institutionUserId ?? null,
          downloadOption : this.downloadOption,
          enrollment_no: this.enrollmentNo || null
        };
      }
      await this.$axios
        .post(url, params, { responseType: "blob" })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "student academic details.pdf");
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.downloadData = false;
        })
        .catch(() => {
          this.$toast.error('Failed to download', {
            position: "top",
            duration: 7000,
          });
        });
      this.loadingPdf = false;
    },
    async getAcademicDetails() {
      try {
        const baseUrl = this.$store.getters.getAPIKey.mainAPI;
        const url = this.from_parent_login
          ? `${baseUrl}/parentuser/usersubgroupuser/academicdetails`
          : `${baseUrl}/usersubgroupuser/academicdetails`;

        let data;
        if (this.from_parent_login) {
          data = {
            institution_user_id: this.institutionUserId,
            subgroupId: this.parentSelectedSubgroupId,
          };
        } else {
          data = {
            usersubgroup_id: this.groupInfo ? this.groupInfo.id: null,
            institution_user_id: this.institutionUserId ?? null
          };
        }

        const response = await this.$axios.post(url, data);
        this.studentUniversityExamsDetails = response.data.studentUniversityExamsDetails;
        this.studentAcademicDetails = response.data.studentAcademicDetails;
        this.institutionUserPersonalDetails = response.data.institutionUserPersonalDetails;
      } catch (error) {
        console.error(error);
      }
    },
    async getSubGroup() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroups/${this.groupInfo.id}?all_data=1`;
      try {
        const response = await this.$axios.get(url);
        this.userSubGroup = response.data;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
<style scoped>
.institution-name {
  font-size: 50rem;
  font-weight: bold;
  font-family: "Roboto", sans-serif;
  letter-spacing: 4px;
  text-transform: uppercase;
  transform: scale(1.5);
}

.section-container {
  padding: 14px;
  background-color: #f9f9f9;
  border-radius: 0px;
}

.capitalize {
  text-transform: capitalize;
}
</style>